import { Suspense } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { SidebarInset, SidebarProvider, Skeleton, Toaster } from '@/lib/macondo';
import { AppSidebar } from './AppSidebar';
import { Topbar } from './Topbar';

export function AppShell() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <SidebarProvider selectedItem={pathname} onItemSelect={(path) => navigate(path)}>
      <AppSidebar />
      {/* min-w-0: a flex item's minimum width defaults to its content's, so one wide
          table (even inside an overflow-x-auto wrapper) pushed the whole page sideways
          next to the sidebar. The table scrolls in its own box instead. */}
      <SidebarInset className="min-w-0">
        <Topbar />
        <div className="flex-1 p-400 md:p-600">
          <Suspense fallback={<Skeleton className="h-1600 w-full" />}>
            <Outlet />
          </Suspense>
        </div>
      </SidebarInset>
      <Toaster />
    </SidebarProvider>
  );
}
